'use client'

import { useEffect, useRef } from 'react'

import { TRoomsEvent } from '@/entities/room'
import { useAirbridgeContext } from '@/shared/config'

type Props = {
  airbridgeEvent: TRoomsEvent | null
}

export const AirbridgeEventSender = ({ airbridgeEvent }: Props) => {
  const { sendEvent, isInitialized } = useAirbridgeContext()
  const sentIdRef = useRef<string>('')

  useEffect(() => {
    if (!airbridgeEvent) {
      return
    }

    const eventKey = `${airbridgeEvent.action} ${airbridgeEvent.label}`

    // initialized 되지 않았거나 strict mode 중복인 경우 return
    if (!isInitialized || sentIdRef.current === eventKey) {
      return
    }

    sentIdRef.current = eventKey

    const params = {
      action: airbridgeEvent.action,
      label: airbridgeEvent.label,
      value: airbridgeEvent.value,
    }

    sendEvent({
      event: airbridgeEvent.eventName,
      params,
    })
  }, [airbridgeEvent, isInitialized, sendEvent])

  return null
}
